import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedTabComponent } from "./med-tab.component";

@NgModule({
  declarations: [
    MedTabComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedTabComponent,
  ],
})
export class MedTabModule { }
